import type { TFunction } from "i18next"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import {
  SUPPLIER_ONBOARDING_STEP_DEFS,
  type SupplierOnboardingStep,
  type SupplierOnboardingStepDef,
} from "~/pages/SupplierPortal/Onboarding/constants/supplierOnboardingSteps"

const toTranslatedStep = (
  step: SupplierOnboardingStepDef,
  t: TFunction<"supplier">
): SupplierOnboardingStep => {
  switch (step.id) {
    case "welcome":
      return {
        ...step,
        name: t("onboarding.steps.welcome.name"),
        title: t("onboarding.steps.welcome.title"),
        subtitle: t("onboarding.steps.welcome.subtitle"),
      }
    case "verify_company":
      return {
        ...step,
        name: t("onboarding.steps.verify_company.name"),
        title: t("onboarding.steps.verify_company.title"),
        subtitle: t("onboarding.steps.verify_company.subtitle"),
      }
    case "register_bp":
      return {
        ...step,
        name: t("onboarding.steps.register_bp.name"),
        title: t("onboarding.steps.register_bp.title"),
        subtitle: t("onboarding.steps.register_bp.subtitle"),
      }
    case "my_facilities":
      return {
        ...step,
        name: t("onboarding.steps.my_facilities.name"),
        title: t("onboarding.steps.my_facilities.title"),
        subtitle: t("onboarding.steps.my_facilities.subtitle"),
      }
    case "review":
      return {
        ...step,
        name: t("onboarding.steps.review.name"),
        title: t("onboarding.steps.review.title"),
        subtitle: t("onboarding.steps.review.subtitle"),
      }
  }
}

export const useSupplierOnboardingSteps =
  (): readonly SupplierOnboardingStep[] => {
    const { t } = useTranslation("supplier")

    return useMemo(
      () =>
        SUPPLIER_ONBOARDING_STEP_DEFS.map((step) => toTranslatedStep(step, t)),
      [t]
    )
  }
